module.exports = __webpack_public_path__ + "static/media/food.1cd39c80.png";